import { Component, OnInit } from '@angular/core';
import { HcaMemberService } from '../../../../../../shared/_services/hca-member.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { StatusModalComponent } from '../../../../../modals/status-modal/status-modal.component';

@Component({
  selector: 'app-members-shopping-cart',
  templateUrl: './members-shopping-cart.component.html',
  styleUrls: ['./members-shopping-cart.component.scss']
})
export class MembersShoppingCartComponent implements OnInit {
  memberSubscription: Subscription;
  memberInfo: any;
  totalCount: number;
  p: number = 0;
  size: number = 10;
  shoppingCartList: any[];
  memberId: number | string;
  statusModal: BsModalRef;
  private unsubscribe: Subject<void> = new Subject<void>();
  destroySubscription$: Subject<boolean> = new Subject();

  constructor(
    private modalService: BsModalService,
    private hcaMemberService: HcaMemberService
  ) {
    this.modalService.onHide
      .takeUntil(this.unsubscribe)
      .subscribe(res => {
        if (this.statusModal) {
          if (this.statusModal.content.srcObject.action == "action1") {
            if (this.statusModal.content.srcObject.type == "cart-edit") {
              if (this.statusModal.content.srcObject.status || this.statusModal.content.srcObject.status == 0) {
                let status = +this.statusModal.content.srcObject.status;
                this.activateOrDeactivate(this.statusModal.content.srcObject.id, status);
              } else {
                this.getShoppingCartDetails();
              }
            }
          }
        }
      })
  }

  activateOrDeactivate(cartId, statusId) {
    console.log(`change status for ${cartId} to ${statusId == 0 ? 'Deactivate' : 'Activate'}`);
    this.hcaMemberService.activateOrDeactivateShoppingCart(cartId, statusId).subscribe(res => {
      this.getShoppingCartDetails();
    }, err => {
      console.error('Error while updating promotion status: ', err.message);
    });
  }

  updateBadgeStatus(memberId, type) {
    this.hcaMemberService.updateBadgeEvents(memberId, type).subscribe(res => {
      if (res.error == 0) {
        this.memberInfo = res.responseObj;
        this.hcaMemberService.setMember(this.memberInfo);
      }
    }, err => {
      console.error('Error while updating member issue status by Id: ', err.message);
    });
  }

  getShoppingCartDetails(pageNum?) {
    this.p = pageNum ? pageNum : this.p;
    if (this.memberInfo && this.memberInfo.nonAutomaticRedemtion) {
      this.updateBadgeStatus(this.memberId, 'nonAutomaticRedemtion');
    }
    this.hcaMemberService.getShoppingCartDetailsByMemberId(this.p > 0 ? this.p - 1 : this.p, this.memberId).subscribe(res => {
      if (res.error == 0) {
        this.shoppingCartList = res.responseObj && res.responseObj.results && res.responseObj.results.length ? res.responseObj.results : [];
        this.totalCount = res.responseObj && res.responseObj.totalRecords ? res.responseObj.totalRecords : 0;
      }
    }, err => {
      console.error('Error while fetching shopping cart list with member id: ', err.message);
    })
  }

  openStatusModal(id?, mode?) {
    this.statusModal = this.modalService.show(StatusModalComponent, { class: 'confirm-modal' });
    let message = "Are you sure you want to change the status of cart?";
    let title = "Change Cart Status";
    let action1 = mode == 1 ? "Pending" : "Closed";
    let style = mode == 1 ? "inactive" : "active";
    let status = mode;
    this.statusModal.content.srcObject = {
      mode: "custom",
      type: 'cart-edit',
      title: title,
      message: message,
      status,
      id: [id],
      action1: action1,
      action2: 'Cancel',
      action: '',
      style: style
    }
  }

  ngOnInit() {
    this.memberId = this.hcaMemberService.getMemberId;
    this.memberInfo = this.hcaMemberService.getMemberInfo;
    this.getShoppingCartDetails();
    this.memberSubscription = this.hcaMemberService.memberData$
      .takeUntil(this.destroySubscription$)
      .subscribe((state: any) => {
        if (state) {
          this.memberInfo = state;
          if (this.memberInfo && this.memberInfo.nonAutomaticRedemtion) {
            this.updateBadgeStatus(this.memberId, 'nonAutomaticRedemtion');
          }
        }
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    this.destroySubscription$.next(true);
    this.destroySubscription$.complete();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/concierge/members-management/members-shopping-cart/members-shopping-cart.component.ts